import { BasicEvent } from "./BasicEvent";
export class VirkesorderStatusChangedEventMessage extends BasicEvent {
    arbetsorderId: number;
    aktuellVirkesorderStatus: string;
    senastSkickadVirkesorder?: Date;
    senastAckadGeneration?: number;
    aktuellVirkesorderNummer: string;
    isDirty: boolean;
    statusar: IArbetsorderVirkesorderStatus[];
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "VirkesorderStatusChangedEventMessage";
}
export interface IArbetsorderVirkesorderStatus {
    status: string;
    nummer: string;
    generation: number;
    isValsVo: boolean;
}
